import React, { useState, useEffect } from "react";
import {
  Grid,
  Box,
  Card,
  CardContent,
  Typography,
  Button,
} from "@mui/material";
import DataTable, { Media } from "react-data-table-component";
import { makeStyles } from "@mui/styles";
import { CardHeading, DashboardCard } from "../Common";
import { useNavigate } from "react-router-dom";

import { useSelector } from "react-redux";

const medal1 = require("../../../assets/images/madel-1.png");
const medal2 = require("../../../assets/images/madel-2.png");
const medal3 = require("../../../assets/images/madel-3.png");
const medal4 = require("../../../assets/images/madel-star.png");

const useStyles = makeStyles({
  rankIcon: {
    height: "24px",
  },
});
const customStyles = {
  rows: {
    style: {
      minHeight: "40px", // override the row height
    },
  },
  headCells: {
    style: {
      paddingLeft: "8px", // override the cell padding for head cells
      paddingRight: "8px",
      fontSize: ".91em",
      fontWeight: "700",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px", // override the cell padding for data cells
      paddingRight: "8px",
      fontWeight: "400",
      fontSize: "0.9em",
    },
  },
};

const LeaderboardCard = ({ leaderboard }) => {
  const classes = useStyles();
  const [sortedData, setSortedData] = useState([]);
  const [points, setPoints] = useState([]);

  const navigate = useNavigate();

  const { role } = useSelector((state) => state.userDetailsReducer);

  const getPoints = (data, id) => {
    if (data.projected) {
      return points[id] !== undefined ? points[id].toFixed(2) : "-";
    } else {
      return "-";
    }
  };

  const conditionalRowStyles = [
    {
      when: (row) => row.id % 2 !== 0,
      style: {
        backgroundColor: "rgba(41, 48, 69, 0.05)",
        color: "#000000",
      },
    },
  ];

  useEffect(() => {
    if (leaderboard?.data?.length > 2) {
      let rankWiseArr = [...leaderboard?.data];

      rankWiseArr.sort(
        (a, b) =>
          (a.projected != null ? a.projected.net : Infinity) -
          (b.projected != null ? b.projected.net : Infinity)
      );

      let tempArr = [];

      if (rankWiseArr.length > 4) {
        for (let a = 0; a < 4; a++) {
          tempArr.push(rankWiseArr[a]);
        }

        rankWiseArr = tempArr;
      }

      for (let j = 0; j < rankWiseArr.length - 1; j++) {
        if (rankWiseArr[j].projected) {
          if (
            rankWiseArr[j]?.projected?.net ===
            rankWiseArr[j + 1]?.projected?.net
          ) {
            // LOGIC 1
            let sum1 = 0;
            let sum2 = 0;
            for (let a = 17; a >= 9; a--) {
              sum1 += parseInt(rankWiseArr[j].score_card[a].score);
              sum2 += parseInt(rankWiseArr[j + 1].score_card[a].score);
            }

            sum1 = sum1 - rankWiseArr[j].playing_handicap / 2;
            sum2 = sum2 - rankWiseArr[j + 1].playing_handicap / 2;

            if (sum1 === sum2) {
              // LOGIC 2
              sum1 = 0;
              sum2 = 0;

              for (let a = 17; a >= 12; a--) {
                sum1 += parseInt(rankWiseArr[j].score_card[a].score);
                sum2 += parseInt(rankWiseArr[j + 1].score_card[a].score);
              }

              sum1 = sum1 - rankWiseArr[j].playing_handicap / 3;
              sum2 = sum2 - rankWiseArr[j + 1].playing_handicap / 3;

              if (sum1 === sum2) {
                // LOGIC 3
                sum1 = 0;
                sum2 = 0;

                for (let a = 17; a >= 15; a--) {
                  sum1 += parseInt(rankWiseArr[j].score_card[a].score);
                  sum2 += parseInt(rankWiseArr[j + 1].score_card[a].score);
                }

                sum1 = sum1 - rankWiseArr[j].playing_handicap / 6;
                sum2 = sum2 - rankWiseArr[j + 1].playing_handicap / 6;

                if (sum1 === sum2) {
                  // LOGIC 4

                  sum1 = 0;
                  sum2 = 0;

                  for (let a = 0; a <= 8; a++) {
                    sum1 += parseInt(rankWiseArr[j].score_card[a].score);
                    sum2 += parseInt(rankWiseArr[j + 1].score_card[a].score);
                  }

                  sum1 = sum1 - rankWiseArr[j].playing_handicap / 2;
                  sum2 = sum2 - rankWiseArr[j + 1].playing_handicap / 2;

                  if (sum2 < sum1) {
                    let tempp = rankWiseArr[j];
                    rankWiseArr[j] = rankWiseArr[j + 1];
                    rankWiseArr[j + 1] = tempp;
                    j = -1;
                  }
                } else {
                  if (sum2 < sum1) {
                    let tempp = rankWiseArr[j];
                    rankWiseArr[j] = rankWiseArr[j + 1];
                    rankWiseArr[j + 1] = tempp;
                    j = -1;
                  }
                }
              } else {
                if (sum2 < sum1) {
                  let tempp = rankWiseArr[j];
                  rankWiseArr[j] = rankWiseArr[j + 1];
                  rankWiseArr[j + 1] = tempp;
                  j = -1;
                }
              }
            } else {
              if (sum2 < sum1) {
                let tempp = rankWiseArr[j];
                rankWiseArr[j] = rankWiseArr[j + 1];
                rankWiseArr[j + 1] = tempp;
                j = -1;
              }
            }
          } else if (
            rankWiseArr[j]?.projected?.net > rankWiseArr[j + 1]?.projected?.net
          ) {
            let tempp = rankWiseArr[j];
            rankWiseArr[j] = rankWiseArr[j + 1];
            rankWiseArr[j + 1] = tempp;
            j = -1;
          }
        }
      }

      let pointValues = [];

      for (let a = 0; a < rankWiseArr.length; a++) {
        let counter = 0;
        let total = 0;
        let avg = 0;

        for (let b = 0; b < rankWiseArr.length; b++) {
          if (
            rankWiseArr[a]?.projected?.net == rankWiseArr[b]?.projected?.net
          ) {
            counter += 1;
            total +=
              (leaderboard.pointsystem[0]?.point_system[b].value / 100) *
              parseInt(leaderboard?.points_multiplier);
          }
        }

        avg = parseFloat(total) / counter;

        pointValues.push(avg);
      }

      setPoints(pointValues);

      setSortedData(rankWiseArr);
      setPoints(pointValues);
    } else {
      setSortedData(leaderboard?.data);
    }
  }, [leaderboard]);

  const columns = [
    {
      name: "Rank",
      selector: (row, params) => {
        if (row?.projected?.net) {
          return params === 0 ? (
            <img src={medal1} alt="medal 1" width="24px" height="24px" />
          ) : params === 1 ? (
            <img src={medal2} alt="medal 2" width="24px" height="24px" />
          ) : params === 2 ? (
            <img src={medal3} alt="medal 3" width="24px" height="24px" />
          ) : params === 3 ? (
            <img src={medal4} alt="medal 4" width="24px" height="24px" />
          ) : null;
        } else {
          return "-";
        }
      },
      // cell: (row) => <RankIconCell row={row} />,
      maxWidth: "24%",
      minWidth: "14%",
      grow: 0,
    },
    {
      name: "Points",
      selector: (row, params) => getPoints(row, params),
      maxWidth: "20%",
      minWidth: "20%",
    },
    {
      name: "Player",
      selector: (row) => `${row?.first_name} ${row?.last_name}`,
      grow: 1,
      // maxWidth: "35%",
      minWidth: "24%",
    },
    {
      name: "Net Score",
      selector: (row) => row?.projected?.net,
      maxWidth: "20%",
      minWidth: "20%",
    },
  ];

  const showAll = () => {
    if (leaderboard?.tournament_id) {
      navigate(`poty-tournaments/${leaderboard?.tournament_id}/view`);

      // if (role === "admin" || role === "super") {
      //   navigate(
      //     `poty-tournaments/${leaderboard?.tournament_id}/tournament-details`
      //   );
      // } else {
      //   navigate(`poty-tournaments/${leaderboard?.tournament_id}/view`);
      // }
    }
  };

  return (
    <DashboardCard
      moreButtonText="Show All"
      showMoreButton={true}
      moreButtonColor="alternate"
      showMoreButtonHasIcon={false}
      buttonBG="#06623B"
      viewMoreButtonNoPaddingTop={true}
      showMoreButtonStyle="button"
      innerCardContentNoPadding={true}
      innerCardNoShadow={true}
      showMoreButtonPlacement="right"
      outerCardNoPaddingTop={true}
      onViewMoreClick={showAll}
    >
      <Box sx={{ marginBottom: 0 }}>
        <CardHeading
          text={
            leaderboard?.tournament_name
              ? leaderboard?.tournament_name
              : "Latest POTY Result"
          }
        />
      </Box>
      <DataTable
        columns={columns}
        data={sortedData}
        // data={data}
        customStyles={customStyles}
        dense
        conditionalRowStyles={conditionalRowStyles}
      />
    </DashboardCard>
  );
};

export default LeaderboardCard;
